// extracted by mini-css-extract-plugin
export var errorIcon = "_ok-1";
export var nameLogo = "_ok-0";